import type { TestableComponent } from "@quortex/front-common"
import type { SegmentResponse } from "@/types/api"

export interface DeviceEditionFormProps extends TestableComponent {
  className?: string
  segmentId?: string
  segmentParentUuid?: string | null
  onChange?: (
    selectedDevices: NonNullable<api.switchns.PatchedSegmentRequest["devices"]>[number][]
  ) => void
}

export interface DeviceFilterGroup {
  name: string
  filters: {
    value: NonNullable<api.switchns.PatchedSegmentRequest["devices"]>[number]
    disabled?: (
      selectedDevices: NonNullable<api.switchns.PatchedSegmentRequest["devices"]>[number][],
      siblings: SegmentResponse[]
    ) => boolean
  }[]
}

export const DeviceFiltersGroup: DeviceFilterGroup[] = [
  {
    filters: [
      {
        disabled: (selectedDevices, siblings) =>
          selectedDevices.includes("desktop") ||
          siblings.some(sibling => sibling.devices?.includes("android")),
        value: "android"
      },
      {
        disabled: (selectedDevices, siblings) =>
          selectedDevices.includes("desktop") ||
          selectedDevices.includes("smarttv") ||
          siblings.some(sibling => sibling.devices?.includes("ios")),
        value: "ios"
      }
    ],
    name: "Operating system"
  },
  {
    filters: [
      {
        disabled: (selectedDevices, siblings) =>
          selectedDevices.includes("android") ||
          selectedDevices.includes("ios") ||
          siblings.some(sibling => sibling.devices?.includes("desktop")),
        value: "desktop"
      },
      {
        disabled: (_, siblings) => siblings.some(sibling => sibling.devices?.includes("mobile")),
        value: "mobile"
      },
      {
        disabled: (selectedDevices, siblings) =>
          selectedDevices.includes("ios") ||
          siblings.some(sibling => sibling.devices?.includes("smarttv")),
        value: "smarttv"
      },
      {
        disabled: (_, siblings) => siblings.some(sibling => sibling.devices?.includes("tablet")),
        value: "tablet"
      }
    ],
    name: "Device Types"
  }
]

export const DeviceLabels: Record<
  NonNullable<api.switchns.PatchedSegmentRequest["devices"]>[number],
  string
> = {
  android: "Android",
  desktop: "Desktop",
  ios: "iOS",
  mobile: "Mobile",
  smarttv: "SmartTv",
  tablet: "Tablet"
}

export { default as DeviceEditionForm } from "./DeviceEditionForm"
